import { inject, Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { LoadingService } from '@portal/loading/data-access';
import { catchError, finalize, throwError } from 'rxjs';
import { ApplicationApiService } from '../api/application-api.service';
import { ApplicationInfoResponse } from '../model/application-info.model';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class GettingStartedResolver implements Resolve<ApplicationInfoResponse> {
  private readonly applicationApi = inject(ApplicationApiService);
  private readonly loadingService = inject(LoadingService);

  resolve() {
    this.loadingService.show();
    return this.applicationApi.getApplicationInfo().pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error)),
      finalize(() => this.loadingService.hide()),
    );
  }
}
